<template>
    <ShotJobComponent />
</template>


<script>
import ShotJobComponent from '@/components/shot-job/ShotJobComponent.vue';


export default {
    name: 'JobView',
    components: {
        ShotJobComponent
    }
}
</script>